import { type ReactNode, useEffect, useState } from 'react'

import { Badge, type BadgeColor } from 'components'

import * as S from './styles'

type OnClickItemType = (index: string) => void

export type ItemActionTabsType = {
  label: string | ReactNode
  status?: BadgeColor
  onClick: OnClickItemType
}

type ActionTabsProps = {
  items: ItemActionTabsType[]
  currentItem: string | number
  disabled?: boolean
  variant?: 'default' | 'contained'
}

export const ActionTabs = ({
  items,
  currentItem,
  disabled,
  variant = 'default',
}: ActionTabsProps) => {
  const [selected, setSelected] = useState<number>(+currentItem)

  useEffect(() => {
    setSelected(+currentItem)
  }, [currentItem])

  const handleSelected = (index: string, callback: OnClickItemType) => {
    setSelected(+index)
    callback(index)
  }

  return (
    <S.ActionTabsWrap id="action-tabs-wrap" variant={variant}>
      {items.map((item, index) => (
        <S.ActionTabsItem
          className={index === +selected ? 'active' : ''}
          disabled={disabled}
          key={index}
          onClick={() => handleSelected(index.toString(), item.onClick)}
          type="button"
          variant={variant}
        >
          {item.label}
          {item.status && <Badge appearance="ping" color={item.status} />}
        </S.ActionTabsItem>
      ))}
    </S.ActionTabsWrap>
  )
}
